import React from 'react'
import * as Yup from 'yup'
import { Box } from 'theme-ui'
import {
  FieldSectionLayout,
  PanelForm,
  SubmitSection,
  TextFieldSection,
} from '../../components/panels/content'

const UnIgnoreComment = ({ onSave }) => {
  return (
    <PanelForm
      validationSchema={Yup.object({
        [`comment`]: Yup.string()
          .required('Required')
          .min(1, 'Remove ignore comment must not be empty')
          .max(200, 'Remove ignore comment must be 200 characters max'),
      })}
      onSubmit={(vals) => {
        onSave({
          comment: vals.comment,
        })
      }}
      initialValues={{ commentUnignore: '' }}
    >
      <Box>
        <TextFieldSection
          name="comment"
          label=""
          height={100}
          description=""
          placeholder="Add your comment here"
          layout={FieldSectionLayout.Vertical}
          merge
        />
        <SubmitSection text="Save" />
      </Box>
    </PanelForm>
  )
}

export default UnIgnoreComment
